const FastForwardIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.28333 16.9375V5.9375L13.2833 11.4375L7.28333 16.9375Z" stroke="currentColor" shapeRendering="crispEdges"/>
            <line x1="14.5292" y1="4.82812" x2="14.5292" y2="18.0781" stroke="currentColor"/>
            <line x1="17.2167" y1="4.82812" x2="17.2167" y2="18.0781" stroke="currentColor"/>
        </svg>
    )
}

export default FastForwardIcon
